// extracted by mini-css-extract-plugin
export default {"container":"HB-z","dimension":"IB-z","dimensionLabels":"JB-z"};